export const TRANSLATION_SCOPE = 'surveyGridModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
export const TRANSLATION_HISTORY_SCOPE = [TRANSLATION_SCOPE, 'history'];
